/* RESPONSIBLE TEAM: team-inbox */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class BenchmarkAvatarUrls extends Fragment {
  @attr declare square_25: string;
  @attr declare square_50: string;
  @attr declare square_128: string;
}
